import styled, { css } from 'styled-components';

export const Container = styled.div<{ hasPadding: boolean }>`
  gap: 24px;
  display: flex;
  flex-direction: column;
  ${({ hasPadding }) =>
    hasPadding &&
    css`
      padding: 16px;
    `}
`;

export const InfoLabel = styled.div`
  color: ${({ theme }) => theme.colors.grey.primary.standard};
  width: 80px;
  min-width: 80px;
`;
